import aubergine from "./aubergine"
import light from "./light"
import green from "./green"
import retro from "./retro"
import dark from "./dark"

const THEMES = { light, green, retro, dark, aubergine }

const LEGACY_THEME_MAP = {
  white: "light",
  grey: "light",
  green: "green",
  retro: "retro",
  black: "dark",
  aubergine: "aubergine",
  night: "dark",
}

export const resolveTheme = name => {
  if (!name) return "light"
  return LEGACY_THEME_MAP[name] || name
}

export const getThemeStyles = name => THEMES[resolveTheme(name)] || THEMES.light

export const lightenColor = (hex, ratio) => {
  const match = /^#([0-9a-f]{6})$/i.exec(hex)
  if (!match) return hex
  const num = parseInt(match[1], 16)
  const r = (num >> 16) & 0xff
  const g = (num >> 8) & 0xff
  const b = num & 0xff
  const mix = c => Math.round(c + (255 - c) * ratio)
  const toHex = c => c.toString(16).padStart(2, "0")
  return `#${toHex(mix(r))}${toHex(mix(g))}${toHex(mix(b))}`
}
